import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState, TableWrap, th, td, fmtDate } from "@/components/dashboard/ui";

export default function AdminWaitlist() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/waitlist");
      setRows(data);
    } catch (e) {
      toast.error("Failed to load waitlist");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="space-y-6" data-testid="admin-waitlist">
      <div>
        <h2 className="font-display text-2xl tracking-tight text-white">Access requests</h2>
        <p className="mt-1.5 text-slate-400">People who requested an invite from the landing page.</p>
      </div>

      {loading ? (
        <div className="py-20 flex justify-center"><Loader2 className="animate-spin text-slate-500" /></div>
      ) : rows.length === 0 ? (
        <EmptyState title="No requests yet" desc="Waitlist submissions from the homepage will appear here." />
      ) : (
        <TableWrap>
          <thead>
            <tr>
              <th className={th}>Name</th>
              <th className={th}>Email</th>
              <th className={th}>Artist / Label</th>
              <th className={th}>Message</th>
              <th className={th}>Received</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.entry_id} data-testid={`waitlist-row-${r.entry_id}`} className="hover:bg-white/[0.02]">
                <td className={td + " text-white"}>{r.name}</td>
                <td className={td}>{r.email}</td>
                <td className={td}>{r.artist_name || "—"}</td>
                <td className={td + " max-w-xs truncate"}>{r.message || "—"}</td>
                <td className={td}>{fmtDate(r.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </TableWrap>
      )}
    </div>
  );
}
